enum ManageEventSessionsMode {
  AddToCart = 'AddToCart',
  UpdateInCart = 'UpdateInCart',
}
export default ManageEventSessionsMode;
